import React from 'react';
import { cn } from '@/utils/cn';
import { TablePagination } from '@/components/ui/TablePagination';
import { CardList } from '@/components/ui/CardList';

export function ProjectLogsList({ logs }: { logs: any[] }) {
  return (
    <div className="bg-white rounded-md border border-slate-100  overflow-hidden">
      {/* Desktop Table */}
      <div className="hidden lg:block overflow-x-auto">
        <table className="w-full text-left border-collapse">
          <thead>
            <tr className="bg-slate-50/50 text-xs font-normal text-slate-400 border-b border-slate-100">
              <th className="py-3 px-4 font-normal">Thời gian</th>
              <th className="py-3 px-4 font-normal">Người thực hiện</th>
              <th className="py-3 px-4 font-normal">Hoạt động</th>
              <th className="py-3 px-4 font-normal">Nội dung</th>
              <th className="py-3 px-4 font-normal">Đối tượng</th>
              <th className="py-3 px-4 font-normal">Chi tiết</th>
            </tr>
          </thead>
          <tbody className="text-xs lg:text-sm divide-y divide-slate-50">
            {logs.map((log) => (
              <tr key={log.id} className="hover:bg-slate-50/50 transition-colors group">
                <td className="py-4 px-4">
                   <div className="flex items-center gap-3">
                      <div className={cn("w-8 h-8 rounded-full flex items-center justify-center shrink-0 border border-slate-50", log.iconBg, log.iconColor)}>
                         <i className={cn(log.icon, "text-sm")} />
                      </div>
                      <span className="text-xs font-normal text-slate-400 whitespace-nowrap">{log.time}</span>
                   </div>
                </td>
                <td className="py-4 px-4">
                  <div className="flex items-center gap-3">
                    <img src={log.user.avatar} alt="" className="w-8 h-8 rounded-full border border-slate-100 shrink-0" />
                    <div className="flex flex-col min-w-0">
                      <span className="font-normal text-slate-700 truncate">{log.user.name}</span>
                      <span className="text-xs text-slate-400">{log.user.role}</span>
                    </div>
                  </div>
                </td>
                <td className="py-4 px-4">
                   <span className={cn("px-2 py-0.5 rounded-md text-xs font-normal whitespace-nowrap", log.actionColor)}>{log.action}</span>
                </td>
                <td className="py-4 px-4">
                   <p className="font-normal text-slate-700 leading-relaxed max-w-[300px]">{log.content}</p>
                </td>
                <td className="py-4 px-4">
                   <div className="flex flex-col text-xs font-normal">
                      <span className="text-slate-400 tracking-wider"> {log.target.type}</span>
                      <span className="text-slate-600 truncate max-w-[150px]">{log.target.name}</span>
                   </div>
                </td>
                <td className="py-4 px-4 font-normal text-slate-500 whitespace-nowrap">
                   {log.detail}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Mobile Card List */}
      <div className="lg:hidden p-4">
        <CardList 
          items={logs}
          renderCard={(log) => (
            <div key={log.id} className="bg-white p-3 rounded-md border border-slate-100 space-y-4">
              <div className="flex justify-between items-start">
                <div className="flex items-center gap-3">
                   <div className={cn("w-8 h-8 rounded-full flex items-center justify-center shrink-0", log.iconBg, log.iconColor)}>
                      <i className={cn(log.icon, "text-sm")} />
                   </div>
                   <div className="space-y-0.5">
                      <p className="text-xs font-normal text-slate-400">{log.time}</p>
                      <span className={cn("px-2 py-0.5 rounded-md text-xs font-normal", log.actionColor)}>{log.action}</span>
                   </div>
                </div>
              </div>
              <p className="text-xs font-normal text-slate-700 leading-relaxed">{log.content}</p>
              <div className="flex items-center gap-2 border-t border-slate-50 pt-3">
                 <img src={log.user.avatar} alt="" className="w-6 h-6 rounded-full" />
                 <span className="text-xs font-normal text-slate-600">{log.user.name}</span>
                 <span className="text-xs text-slate-300">|</span>
                 <span className="text-xs font-normal text-slate-400">{log.target.type}</span>
              </div>
            </div>
          )}
        />
      </div>

      <div className="px-4 border-t border-slate-50 bg-slate-50/30">
        <TablePagination currentPage={1} totalItems={245} pageSize={10} onPageChange={() => {}} itemLabel="hoạt động" />
      </div>
    </div>
  );
}
